import { z } from 'zod';

export const getDiscountSchema = z.object({ code: z.string().min(5) });

export type GetDiscountSchema = z.infer<typeof getDiscountSchema>;
